module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.START),
      expression: "sharedStore.gameState == common.START"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-on",
    on: {
      "click": function($event) {
        _vm.startGame()
      }
    }
  }, [_vm._v("\n            Start a New Match\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.PLAYING),
      expression: "sharedStore.gameState == common.PLAYING"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.pausePlay()
      }
    }
  }, [_vm._v("\n            Stop Play\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.PAUSED),
      expression: "sharedStore.gameState == common.PAUSED"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.resumePlay()
      }
    }
  }, [_vm._v("\n            Start Play\n        ")])]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.END),
      expression: "sharedStore.gameState == common.END"
    }],
    staticClass: "top-buttons heading"
  }, [_vm._v("\n        End of Play\n    ")]), _vm._v(" "), (_vm.sharedStore.gameState > _vm.common.START) ? _c('section', [_c('section', {
    class: {
      'is-stopped': _vm.sharedStore.gameState != _vm.common.PLAYING, 'is-paused': _vm.sharedStore.gameState == _vm.common.PAUSED, 'is-end': _vm.sharedStore.gameState == _vm.common.END
    }
  }, [_c('div', {
    staticClass: "time-desc"
  }, [_vm._v("\n                Game Time\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "time-large"
  }, [_vm._v("\n                " + _vm._s(_vm._f("formatTime")(_vm.currentGameTime)) + "\n            ")])]), _vm._v(" "), _c('section', {
    class: {
      'hidden': _vm.currentPaused < 1
    }
  }, [_c('div', {
    staticClass: "time-paused",
    class: {
      'time-paused-paused': _vm.sharedStore.gameState == _vm.common.PAUSED, 'time-paused-paused-flash': _vm.sharedStore.gameState == _vm.common.PAUSED && _vm.currentPaused % 2
    }
  }, [_vm._v("\n                Play Stopped for " + _vm._s(_vm._f("formatTime")(_vm.currentPaused)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.sharedStore.gameState === _vm.common.EDIT) ? _c('team') : _vm._e(), _vm._v(" "), (_vm.sharedStore.gameState >= _vm.common.START) ? _c('section', [_c('transition-group', {
    staticClass: "players",
    attrs: {
      "name": "anim-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.playersFiltered), function(player) {
    return _c('li', {
      key: player.id,
      staticClass: "player",
      class: {
        'player-on': player.isOn === 1, 'player-time-stopped': _vm.sharedStore.gameState != _vm.common.PLAYING
      },
      on: {
        "click": function($event) {
          _vm.clickPlayer(player)
        }
      }
    }, [_c('strong', {
      staticClass: "left-col player-name"
    }, [_vm._v(_vm._s(player.playerName))]), _vm._v(" "), _c('span', {
      staticClass: "right-col player-seconds"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(player.secondsOn)))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.PAUSED),
      expression: "sharedStore.gameState == common.PAUSED"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.endGame()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.sharedStore.endWarning ? "Are you sure?" : "End Game") + "\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.START),
      expression: "sharedStore.gameState == common.START"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.editPlayers()
      }
    }
  }, [_vm._v("\n            Add or Change Players\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.EDIT && _vm.sharedStore.players3.length > 0),
      expression: "sharedStore.gameState == common.EDIT && sharedStore.players3.length > 0"
    }]
  }, [_c('button', {
    staticClass: "button-large button-large-on",
    on: {
      "click": function($event) {
        _vm.savePlayers()
      }
    }
  }, [_vm._v("\n            Done Editing,\n            " + _vm._s(_vm.sharedStore.players3.length) + " Player" + _vm._s(_vm._f("pluralize")(_vm.sharedStore.players3.length)) + "…\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.END),
      expression: "sharedStore.gameState == common.END"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.clearGame()
      }
    }
  }, [_vm._v("\n            Clear Game and Start Over\n        ")])]), _vm._v(" "), (_vm.sharedStore.gameState >= _vm.common.START && _vm.sharedStore.logList.length) ? _c('section', [_c('h4', {
    staticClass: "sub-log-title"
  }, [_vm._v("\n            Substitution" + _vm._s(_vm._f("pluralize")(_vm.sharedStore.logList.length)) + "\n            "), _c('span', {
    staticClass: "sub-log-title-right"
  }, [_vm._v("Time On")])]), _vm._v(" "), _c('ul', {
    staticClass: "sub-log"
  }, _vm._l((_vm.sharedStore.logList), function(log) {
    return _c('li', {
      key: _vm.sharedStore.logList['id'],
      staticClass: "sub-log-li"
    }, [_c('strong', {
      staticClass: "left-col player-name"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("formatTime")(log['logTime'])) + " " + _vm._s(log['logPlayer'].playerName) + " " + _vm._s(_vm._f("logFormatDesc")(log)) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "right-col"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("logFormatTime")(log['logTotalOn'])) + "\n                ")])])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf06717","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 25
// module chunks = 0